export default {
    mobileVersion: state => state.mobileVersion,
    pageName: state => state.pageName,
    search: state => state.search,
    searchWrite: state => state.searchWrite,
    mobileMenuIsOpen: state => state.mobileMenuIsOpen,
    headerBannerScrollActive: state => state.headerBannerScrollActive,
};
